import React, { useState, useRef, useEffect } from "react";
import StaffInfo from "../../component/profile/staffInfo";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import ImageTag from "../../component/reusebale/imageTag";
import Clock from "../../component/profile/clock";
import PreviousShift from "../../component/profile/previousShift";
import { useSelector, useDispatch } from "react-redux";
import { ArrowLeft } from "lucide-react";
import * as AuthAction from "../../store/actions/auth/AuthAction";

const ViewProfile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { loginSuccess } = useSelector((state) => state.auth);

  const { currentShift } = useSelector((state) => state.data);
  // State to toggle dropdown
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Check authentication state
  useEffect(() => {
    const initializeProfile = async () => {
      if (!loginSuccess) {
        if (AuthAction.hasValidLoginCredentials()) {
          await dispatch(AuthAction.HydrateStateAction());
        } else {
          navigate("/login");
        }
      }
    };

    initializeProfile();
  }, [dispatch, navigate, loginSuccess]);

  // Function to toggle menu
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  function GetTimeDifference(checkInDate) {
    const checkIn = new Date(checkInDate);
    const now = new Date();

    let diffMs = Math.abs(now - checkIn); // Get absolute difference in milliseconds
    let diffMinutes = Math.floor(diffMs / (1000 * 60)); // Convert to minutes
    let hours = Math.floor(diffMinutes / 60);
    let minutes = diffMinutes % 60;

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}`;
  }

  return (
    <div className="w-[95%] mx-auto h-screen">
      <div className="h-[15%] flex items-center">
        <div className="w-[25%] flex justify-center items-center">
          <div
            className="flex justify-center items-center mr-3 bg-white w-9 h-9 rounded-full cursor-pointer"
            onClick={() => navigate("/support-chat")}
          >
            <ArrowLeft className="text-themeColor" size={20} strokeWidth={2} />
          </div>
          <div onClick={() => navigate("/support-chat")}>
            <ImageTag
              path="/assets/logo.png"
              classes="w-[200px] object-cover cursor-pointer"
              altText="logo"
            />
          </div>
        </div>
        <div className="w-[75%]">
          <div
            className="flex justify-end items-center relative"
            ref={dropdownRef}
          >
            <div>
              <p className="font-popinsMedium text-xs text-darkColor/60">
                Welcome
              </p>
              <p className="font-popinsSemiBold text-base text-darkColor">
                {`${loginSuccess?.user?.firstName} ${loginSuccess?.user?.lastName} `}
              </p>
            </div>
            <div onClick={toggleMenu}>
              <ImageTag
                path="/assets/daashboard/user/user.png"
                classes="size-[50px] rounded-full cursor-pointer ml-2"
                altText="logo"
              />
            </div>

            {isOpen && (
              <div className="absolute z-20 right-0 top-14 mt-2 w-48 bg-white rounded-lg shadow-lg overflow-hidden transition-all duration-300 font-popinsMedium text-sm">
                <ul className="py-2">
                  <li
                    className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                    onClick={() => navigate("/view-profile")}
                  >
                    View Profile
                  </li>
                  <li
                    className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                    onClick={() => navigate("/reset-password")}
                  >
                    Change Password
                  </li>
                  <li
                    className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                    onClick={() => navigate("/login")}
                  >
                    Logout
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="h-[85%]">
        <div className="flex justify-between">
          <div className="w-[60%]">
            <StaffInfo />
          </div>
          <div className="w-[39%]">
            <Clock />
          </div>
        </div>
        <PreviousShift />
      </div>
    </div>
  );
};

export default ViewProfile;
